import type { SVGProps } from 'react';
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" viewBox="0 0 40 40" {...props}>
    <rect width={40} height={40} fill="#FFEBDA" rx={20} />
    <path
      stroke="#C24E00"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 17v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3l-6.928-12c-.77-1.333-2.694-1.333-3.464 0L11.34 24c-.77 1.333.192 3 1.732 3"
    />
  </svg>
);
export default SvgWarning;
